import { render, staticRenderFns } from "./Sysmenu.vue?vue&type=template&id=0b6fed92&"
import script from "./Sysmenu.vue?vue&type=script&lang=js&"
export * from "./Sysmenu.vue?vue&type=script&lang=js&"
import style0 from "./Sysmenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports